import { MProjectCheckSuccessfulNotification } from "#/store/types";
import { constructURLToMonitoringProject } from "#/util";
import React from "react";
import style from "./index.module.scss";
import ItemWrapper from "./ItemWrapper";
import { DerivedNotificationItemProps } from "./types";

const MProjectCheckSuccessfulNotificationItem = React.forwardRef(
  (
    props: DerivedNotificationItemProps<MProjectCheckSuccessfulNotification>,
    ref: React.Ref<any>,
  ) => (
    <ItemWrapper
      ref={ref}
      onClick={() => {
        props.push(constructURLToMonitoringProject(props.notification.project_model));
      }}
      notification={props.baseNotification}
    >
      <span className={style["notification-menu-item__text"]}>
        Проверка страниц проекта {`"${props.notification.project_model.name}"`} была успешно
        завершена: {props.notification.urls_checked} URL-ов было проверено.
      </span>
    </ItemWrapper>
  ),
);

export default MProjectCheckSuccessfulNotificationItem;
